module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTAgMEM0LjQ4NjA2IDAgMCA0LjQ4NjA2IDAgMTBDMCAxNS41MTM5IDQuNDg2MDYgMjAgMTAgMjBDMTUuNTEzOSAyMCAyMCAxNS41MTM5IDIwIDEwQzIwIDQuNDg2MDYgMTUuNTEzOSAwIDEwIDBaTTguMTczMDggMTUuMDE4M0w0LjI5ODA4IDEwLjcxMkw1LjQ0MTgzIDkuNjgyNjlMOC4xMzQxNCAxMi42NzRMMTQuNTE5MiA1LjA3MDE5TDE1LjY5OSA2LjA1NzY5TDguMTczMDggMTUuMDE4M1oiIGZpbGw9IiMxRkFGMzgiLz4KPC9zdmc+Cgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-check-valid.svg
// module id = hB/s
// module chunks = 1